import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  stroke: PropTypes.string
};

const Arrow = ({stroke = '#fff'}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" fill="none" viewBox="0 0 10 14">
      <path stroke={stroke} strokeWidth="3" d="M2 12l5-5-5-5" />
    </svg>
  );

Arrow.propTypes = propTypes;

export default Arrow;
